'use client';

import { usePaywall } from '@/app_lib/providers/PaywallProvider';
import type { Article } from '@/app_lib/types/Article';
import { ContentPlacement } from '@/app_lib/types/analytics';

export const NativoTout = ({ featuredMediaType }: Pick<Article, 'featuredMediaType'>) => {
  const {
    paywallState: { paywallCheck },
  } = usePaywall();

  const isVideoMedia = ['fortune_video', 'stn_video_media'].includes(featuredMediaType);

  const nativoFeaturedMediaTypeClassName = isVideoMedia ? 'nativo-tout--in-content-video' : 'nativo-tout--in-content';

  const innerClassName = paywallCheck === 'no-paywall' ? `nativo-tout ${nativoFeaturedMediaTypeClassName}` : '';

  return (
    <div className='nativo-wrapper min-h-[270px] md:min-h-[200px] sm:max-h-[570px] md:max-h-auto py-4 box-content'>
      <div
        className={innerClassName}
        data-cy={ContentPlacement.NativoTout}
      />
    </div>
  );
};
